import mergeConfig from 'coact/config/mergeConfig'

import ArrivalProcessPage from './ArrivalProcessPage/index.js'
import saga from './saga.js'

const config = {
  routes: {
    arrivalProcess: {
      title: '採購進貨處理',
      path: '/route/arrivalProcess',
      component: ArrivalProcessPage,
    },
  },
  sagas: {
    arrivalProcessSaga: saga,
  },
}

export default fullConfig => mergeConfig(fullConfig, config)
